import { render, staticRenderFns } from "./InputFileComponent.vue?vue&type=template&id=36325ea6&scoped=true&"
import script from "./InputFileComponent.vue?vue&type=script&lang=js&"
export * from "./InputFileComponent.vue?vue&type=script&lang=js&"
import style0 from "./InputFileComponent.vue?vue&type=style&index=0&id=36325ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36325ea6",
  null
  
)

export default component.exports